/**
 * The German a teacher reads (spec 4.4, CONTEXT.md). Identifiers stay English everywhere;
 * these are the only place the enum values become words, so the wording lives in one file
 * rather than spread across the screens that show it.
 *
 * The unions come from the API's own response types, not from `@scrolivo/domain`: the web app
 * depends on the server's wire contract (ADR 0002) and on nothing else, and a `Record` keyed by
 * the derived union means adding a flag reason on the server fails this build until it has
 * German — which is the point of having it here.
 */

import type { Flag } from "../shared/api-types.js";

export type FlagReason = Flag["reason"];
export type FlagStatus = Flag["status"];

export const FLAG_REASON_LABELS: Record<FlagReason, string> = {
  wrong: "Falsch",
  unclear: "Unklar",
  unsuitable: "Unpassend für Kinder",
  other: "Anderes",
};

/** The order the four reasons are offered in (spec 4.4), derived so it cannot drift. */
export const FLAG_REASONS = Object.keys(FLAG_REASON_LABELS) as FlagReason[];

export const FLAG_STATUS_LABELS: Record<FlagStatus, string> = {
  open: "offen",
  kept: "behalten",
  rewritten: "umgeschrieben",
};

// `Era` needs no mapping: spec 11.2's values are already the German a teacher reads
// ("Urgeschichte und Antike", "Mittelalter", …), so the topic tables print them as they come.
